import { Box, Container, Paper } from '@mui/material';
import { SiTrackPage } from '../../../components/si-track-page';
import { useLoadData } from '../../../hooks/useLoadData';
import { qbApiKeyStore } from '../../../api/quickbook-api-key-store';
import { QboState } from './qbo-state.component';
import { ApiResponse } from '../../../models/api-response';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSaveData } from '../../../hooks/useSaveData';

export const QuickBookResultPage = () => {
  const location = useLocation();
  const [message, setMessage] = useState<string | null>(null);
  // Parse query parameters from the URL
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');
  const realmId = searchParams.get('realmId');
  const state = searchParams.get('state');

  if (
    !code || // Check if code is missing
    !state || // Check if state is missing
    isNaN(Number(realmId)) || // Check if realmId is not a valid number
    typeof code !== 'string' || // Check if code is not a string
    typeof state !== 'string' // Check if state is not a string
  ) {
    return (
      <SiTrackPage title="Quick Book Result" isLoading={false}>
        <Paper elevation={0}>Error: Missing or invalid URL parameters</Paper>
      </SiTrackPage>
    );
  }
  // Convert code and realmId to numbers

  const realmIdNumber = Number(realmId);
  const isCalledRef = useRef(false);

  // Data mutation hook
  const { isLoading, mutateAsync, data } = useSaveData<any>(qbApiKeyStore.qbotoken());

  useEffect(() => {
    // Only trigger mutation when all conditions are met and the mutation hasn't already been triggered
    if (code && realmIdNumber && state && !isCalledRef.current) {
      isCalledRef.current = true; // Mark as called to prevent subsequent calls

      mutateAsync({
        data: {
          code: code,
          realmId: realmIdNumber,
          state: state,
        },
      })
        .then((data: any) => {
          setMessage('QBO Token generated');
        })
        .catch((error) => {
          console.error('Error loading data:', error);
        });
    }
  }, [code, realmIdNumber, state]);

  return (
    <SiTrackPage title="Quick Book" isLoading={!message}>
      <Container sx={{ textAlign: 'center', mt: 10 }}>
        <Box
          sx={{
            display: 'inline-block',
            borderRadius: '12px',
            backgroundColor: '#f2f2f2',
            padding: '40px',
            boxShadow: '0 3px 6px rgba(0,0,0,0.1)',
          }}
        >
          {message && message}
        </Box>
      </Container>
    </SiTrackPage>
  );
};
